// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3KZIx","header":"MergedInvoice_header__3Q42r"};